// Showtime Product Enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Collapsible sections functionality
  const collapsibleSections = document.querySelectorAll('[data-collapsible]');
  
  collapsibleSections.forEach(section => {
    const trigger = section.querySelector('[data-collapsible-trigger]');
    const content = section.querySelector('[data-collapsible-content]');
    
    if (trigger && content) {
      // Set initial state
      content.style.maxHeight = '0px';
      content.style.overflow = 'hidden';
      content.style.transition = 'max-height 0.3s ease, padding 0.3s ease';
      content.style.paddingTop = '0';
      content.style.paddingBottom = '0';
      
      trigger.addEventListener('click', function() {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        // Toggle aria-expanded
        trigger.setAttribute('aria-expanded', !isExpanded);
        
        // Toggle content visibility with animation
        if (isExpanded) {
          content.style.maxHeight = '0px';
          content.style.paddingTop = '0';
          content.style.paddingBottom = '0';
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.paddingTop = '1rem';
          content.style.paddingBottom = '1rem';
        }
        
        // Add/remove active class for styling
        section.classList.toggle('is-expanded', !isExpanded);
      });
    }
  });

  // Size guide toggle functionality
  const sizeGuideToggle = document.querySelector('[data-size-guide-toggle]');
  if (sizeGuideToggle) {
    sizeGuideToggle.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Create a simple modal or alert for size guide
      // In a real implementation, this could open a modal with detailed size information
      alert('Size Guide:\n\nThis item fits true to size according to customer feedback.\n\nFor specific measurements and fitting advice, please contact our customer service team.');
    });
  }

  // Dynamic shipping date calculation
  function updateShippingDate() {
    const shippingDateElement = document.querySelector('.shipping-info__date');
    if (shippingDateElement) {
      const today = new Date();
      const shippingDate = new Date(today);
      
      // Add 3 days, but skip weekends
      let daysAdded = 0;
      while (daysAdded < 3) {
        shippingDate.setDate(shippingDate.getDate() + 1);
        // Skip weekends (Saturday = 6, Sunday = 0)
        if (shippingDate.getDay() !== 0 && shippingDate.getDay() !== 6) {
          daysAdded++;
        }
      }
      
      const options = { month: 'long', day: 'numeric' };
      shippingDateElement.textContent = shippingDate.toLocaleDateString('en-US', options);
    }
  }

  // Update shipping date on page load
  updateShippingDate();

  // Add smooth animations to new elements
  const newElements = document.querySelectorAll('.authenticity-badge, .shipping-info, .size-fit-guide, .product-collapsible-sections');
  newElements.forEach((element, index) => {
    element.style.opacity = '0';
    element.style.transform = 'translateY(20px)';
    
    // Animate in after a short delay
    setTimeout(() => {
      element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      element.style.opacity = '1';
      element.style.transform = 'translateY(0)';
    }, 100 * (index + 1)); // Stagger the animations
  });
});